import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { UserViewModel } from "@mikros/library/src/model";
import { SearchFilter } from "./searchFilter";
// import { UserCourseData } from "./userCourseData";
import { FetchAllUsers, UserCoursesModel } from "@mikros/library";
import { UserCourseDataDup } from "./userCourseDataDup";
import { SearchFilterDup } from "./searchFilterDup";
import { UserCourseDataDuplicate } from "./userCourseDataDuplicate";

export function UserView() {
  const [userModelData, setUserModelData] = useState<UserViewModel[]>([]);
  // const [userCourseModel, setUserCoursesModel] = useState<UserCoursesModel>({
  //   users: [],
  //   lastKey: "",
  // });

  const [userFetchModel, setUserFetchModel] = useState<FetchAllUsers>({
    users: [],
    lastKey: "",
  });
  const [totalUserCount, setTotalUserCount] = useState<number>(0);
  const [page, setPage] = useState(0);
  const [searchActive, setSearchActive] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    branchName: "",
    department: "",
    location: "",
    designation: "",
  });
  const [hasMoreData, setHasMoreData] = useState(true); // Track if more data is available

  return (
    <div className="mt-6">
      <div className="text-mk-primary-bright text-2xl font-semibold">
        <FormattedMessage id="analytics.userView.searchUsers" />
      </div>
      <div className="pb-[1%]"></div>
      {/* <SearchFilter
        userDataCont={userCourseModel}
        userDataContFunction={setUserCoursesModel}
        totalCount={totalUserCount}
        totalCountFunction={setTotalUserCount}
        search={searchActive}
        searchFunction={setSearchActive}
        formData={formData}
        formDataFunction={setFormData}
        hasMoreData={hasMoreData}
        hasMoreDataFunction={setHasMoreData}
      /> */}

      <SearchFilterDup
        userDataCont={userFetchModel}
        userDataContFunction={setUserFetchModel}
        totalCount={totalUserCount}
        totalCountFunction={setTotalUserCount}
        search={searchActive}
        searchFunction={setSearchActive}
        formData={formData}
        formDataFunction={setFormData}
        hasMoreData={hasMoreData}
        hasMoreDataFunction={setHasMoreData}
      />

      <div className="pb-[1%]"></div>

      {/* <UserCourseDataDup
        // <UserCourseData
        userDataCont={userCourseModel}
        userDataContFunction={setUserCoursesModel}
        totalCount={totalUserCount}
        totalCountFunction={setTotalUserCount}
        search={searchActive}
        searchFunction={setSearchActive}
        formData={formData}
        formDataFunction={setFormData}
        hasMoreData={hasMoreData}
        hasMoreDataFunction={setHasMoreData}
      /> */}

      <UserCourseDataDuplicate
        // <UserCourseData
        userDataCont={userFetchModel}
        userDataContFunction={setUserFetchModel}
        totalCount={totalUserCount}
        totalCountFunction={setTotalUserCount}
        search={searchActive}
        searchFunction={setSearchActive}
        formData={formData}
        formDataFunction={setFormData}
        hasMoreData={hasMoreData}
        hasMoreDataFunction={setHasMoreData}
      />
      <div className="pb-[10%]"></div>
    </div>
  );
}
